export const emailStatus = {
  success: "Delivered",
  fail: "Failed"
};
